import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {Inject, Injectable} from "@angular/core";
import {ajs_$rootScope_DI_TOKEN, AjsRootScopeService} from "web-ng2/tjenester/ajs/AjsRootScopeService";
import {initDebugger} from "../../støttefunksjoner/debug";
import {HttpResponskoder} from "./httpResponskoder";
import {httpUnauthorizedEvent} from "felles/infrastruktur/Tilgangshaandtering";
import {IHttpResponse, IRequestConfig} from "angular";

const debug = initDebugger('ApiVersjonResponsHeadereHttpInterceptor');

/**
 * Interceptor som broadcaster en
 * httpUnauthorizedEvent event på ajs rootScope ved 401 feil
 */
@Injectable()
export class HttpUnauthorizedEventVed401ResponsHttpInterceptor implements HttpInterceptor {

    constructor(@Inject(ajs_$rootScope_DI_TOKEN) private $rootScope: AjsRootScopeService) {
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
          .pipe(
            catchError((feil: HttpErrorResponse) => {
                if (feil.status == HttpResponskoder.UNAUTHORIZED)
                    this.broadcastAjsHttpUnauthorizedEvent(feil, req);
                throw feil; //sørger for at kaller fortsatt blir informert om feilen
            }));
    }

    private broadcastAjsHttpUnauthorizedEvent(feil: HttpErrorResponse, req: HttpRequest<any>){
        //denne info forventes i ajs-koden som håndtere httpUnauthorizedEvent, se lederplan-klient/src/scripts/web/tjenester/Utlogging.ts
        const ajsRequestinfo:Partial<IHttpResponse<any>> = {status: feil.status, config:{url:req.url} as IRequestConfig} ;

        //må kjøres i $applyAsync for at ajs skal fange opp endringer
        this.$rootScope.$applyAsync(() => this.$rootScope.$broadcast(httpUnauthorizedEvent, ajsRequestinfo));
    }
}
